/**
 * The global transform of a Node3D of the Live scene tree, read from the transforms of the nodes on
 * the way down to it, so it holds across an instance border.
 */
import { descendsFromClass } from '../godot/classdb/classBaseTypes.js';
import { NO_PATCHES, patchedNode } from './nodePatch.js';
import { globalMatrix3D, matrixToTransform3D } from './nodeTreeTransforms.js';
/**
 * The global transform of the Node3D at the live path `path`, or null where the path names no node
 * or a node that is not a Node3D. `placed` holds what a pass has moved so far, which the walk reads
 * in place of the node's own transform.
 */
export function liveGlobalTransform3D(tree, path, placed = NO_PATCHES) {
    const target = tree.at(path)?.step.node;
    if (!target || !descendsFromClass(target.type, 'Node3D'))
        return null;
    return matrixToTransform3D(globalMatrix3D(path, nodesOnTheWayTo(tree, path, placed)));
}
/** The node at each prefix of `path`, by prefix, each with the patch `placed` holds for it. */
export function nodesOnTheWayTo(tree, path, placed) {
    const nodes = new Map();
    let prefix = '';
    for (const name of path.split('/')) {
        prefix = prefix ? `${prefix}/${name}` : name;
        const node = tree.at(prefix)?.step.node;
        if (node)
            nodes.set(prefix, patchedNode(node, placed.get(prefix)));
    }
    return nodes;
}
//# sourceMappingURL=liveGlobalTransform.js.map